import React from 'react';
import './TutorialSkeleton.scss';
import { Skeleton } from 'antd';

export default function TutorialSkeleton() {

    const array = new Array(8);

    return (
        <div className='tutorial-skeleton-container'>
            <div className='grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-6'>
                {
                    Array.from({ length: 5 })?.map(() => (
                        <div className='w-full skeleton-card-wrapper rounded-t-2xl'>
                            <Skeleton.Image active={true} />
                            <div className='p-4 text-center'>
                                <Skeleton.Input className='skeleton-purple' active={true} block={true} size='small' />
                                <div className='mt-2'>
                                    <Skeleton.Input className='skeleton-purple' active={true} block={true} size='small' />
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
